import { useTranslation } from 'react-i18next'
import { AddSubdivision } from '~/features/common/Taxipark/Subdivisions/AddSubdivision'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'subdivisions', link: '/taxipark/subdivisions' },
  { titleI18n: 'create subdivision' },
]

export const AddSubdivisionPage = () => {
  const { t } = useTranslation()
  return (
    <PageContainer title={t('create subdivision')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('create subdivision')}</PageTitle>
      </Container>
      <AddSubdivision />
    </PageContainer>
  )
}
